import "./gift-cards-head-cell-content.scss";
import IconInfo from "../../../../../components/icons/icon-info/icon-info";
import { Tooltip } from "../../../../../components/tooltip/tooltip";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import Icon from "../../../../../components/icons/icon/icon";

const GiftCardsHeadCellContent: React.FC = () => {
    return (
        <span className="gift-cards-head-cell-content">
            gift cards <Tooltip
                content={<FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                    Detailed gift card transactions refer only to gift cards issued as refunds via ReturnGO
                </FontBody2>}
            >
                <Icon Component={IconInfo} />
            </Tooltip>
        </span>
    );
}

export default GiftCardsHeadCellContent;
